import axios from "axios";

const apiClient = () => {
  const instance = axios.create({
    baseURL:"https://api.zabali.co/",
    timeout: 60000,
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
    },
    withCredentials: true,
  });

  return instance;
};
export { apiClient };
